import { mergeHits, mergeFacets } from '~/assets/js/utils/algolia.js'

export const useAlgoliaListing = async ({
  requests = [],
  fetchOnLoad = true,
}) => {
  const staticFacets = ref([])
  const { data } = await useAlgolia({ requests, fetchOnLoad })

  const hits = computed(() => {
    const hits = mergeHits(data.value?.results || [])
    return hits
  })

  const facets = computed(() => {
    const facets = mergeFacets(
      data.value?.results?.map((res) => res.facets) || [],
    )
    if (!staticFacets?.value?.length) {
      staticFacets.value = facets
    }

    return facets
  })

  const nbPages = computed(() => {
    // Ritorno il numero di pagine della ricerca che ne ha di più. Se una ricerca ha 3 pagine e l'altra 2 ritornerò 3 in modo che se le pagine selezioante sono 1 e 2 ritorno i dati di tutte e due le ricerche se invece è 3 ritorno solo i dati della prima ricerca
    const nbPages = data.value?.results?.reduce(
      (max, item) => Math.max(max, item.nbPages),
      0,
    )

    return nbPages
  })

  return { hits, facets, staticFacets, nbPages }
}
